import { en } from './en';
import type { TranslationResource } from './en';

export function defineTranslation(overrides: Partial<TranslationResource>): TranslationResource {
  return { ...en, ...overrides };
}
